import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchConToken } from 'helpers/fetch';
import { useTranslation } from 'react-i18next';
import { getDataSession, validarExisteSucursalPrincipal } from 'views/Utils/Common';
import ListTable from 'components/table/ListTable';
import RenderButtons from 'components/table/RenderButtons';
import Swal from 'sweetalert2';
import Modal from 'components/modal/Modal';
import { useModal } from 'hooks/useModal';
import { useGlobalState } from 'resources/GlobalStateContext';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { SelectorConexion } from '../articulos/SelectorConexion';
import shopify from 'images/panel/conexiones/shopify.png';
import tiendanube from 'images/panel/conexiones/tiendanube.png';
import woocommerce from 'images/panel/conexiones/woocommerce.png';
import DeleteIcon from '@mui/icons-material/Delete';

const List = ({ match, saludo, subtitulo }) => {
    const { path } = match;
    const { t } = useTranslation('common');
    const [noDisponible,] = useState('NoDisponible');
    const { setGlobalTitulo } = useGlobalState();
    const [tipoCategoria, setTipoCategoria] = useState('P');
    const [actualizarTabla, setActualizarTabla] = useState(false);
    const [modalValor, setModalValor] = useState(false);
    const [isOpenModalMarketPlace, openModalMarketPlace, closeModalMarketPlace] = useModal(false);
    const [sucursales, setSucursales] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const columns = [
        {
            renderCell: RenderButtons, headerName: '', maxWidth: 20, path: path, opciones: "editar" + (validarSucursal() ? ",asignar,asignarmanual,desvincular" : ""),
            asignarAutomatico: asignar, desvincular: desvincular
        },
        getDataSession('tienda') === 'MERCADOLIBRE' ? { field: 'id', headerName: 'Id', maxWidth: 20 } :
            { field: 'id', headerName: 'Id', maxWidth: 20, renderCell: (params) => (<a href={`${path + '/edit/' + params.row.id}`}>{params.value}</a>) },
        getDataSession('tienda') === 'MERCADOLIBRE' ? { field: 'clave_Categoria', headerName: 'Clave categoria', flex: 1 } :
            { field: 'clave_Categoria', headerName: 'Clave categoria', flex: 1, renderCell: (params) => (<a href={`${path + '/edit/' + params.row.id}`}>{params.value}</a>) },
        { field: 'clave_Categoria_Padre', headerName: 'Clave Categoria Padre', flex: 1 },
        { field: 'clave_sat', headerName: 'Clave SAT', flex: 1 },
        { field: 'nombre', headerName: 'Nombre', flex: 1 },
        { field: 'tipo_Categoria', headerName: 'Tipo Categoria', flex: 1 },
        { field: 'publicado', headerName: 'Publicado', flex: 1, renderCell: (params) => (<span>{params.value ? 'S' : 'N'}</span>) }
    ];

    const FiltroTipoCategoria = () => {
        return (<FormControl fullWidth sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="tipo-categoria-checkbox-label">Tipo Categoria</InputLabel>
            <Select onChange={handleChange} value={tipoCategoria} label="Conexión">
                <MenuItem key='T' value='T'><ListItemText primary='Todos' /></MenuItem>
                <MenuItem key='P' value='P'><ListItemText primary='(P) Principal' /></MenuItem>
                <MenuItem key='S' value='S'><ListItemText primary='(S) Secundario' /></MenuItem>
                <MenuItem key='C' value='C'><ListItemText primary='(C) Final' /></MenuItem>
            </Select>
        </FormControl>);
    };

    const getSucursal = (tienda, parametros) => fetchConToken(`Sucursales/GetListByTienda?empresa_id=${getDataSession('empresa')}&tienda=${tienda}&${parametros}`);

    async function getSucursalesTienda(tiendaParam) {
        const response = await getSucursal(tiendaParam, 'includeTienda=true&includeMatriz=false');
        setSucursales(response);
    }

    function descargar() {
        var url = getDataSession('rol') === "ADMINISTRADOR" ? `categorias/DescargarCategorias?sucursal_id=${getDataSession('sucursal')}` :
            `categorias/DescargarCategorias?sucursal_id=${getDataSession('sucursal')}&empresa_id=${getDataSession('sucursal')}&tienda=${getDataSession('tienda')}`;
        fetchConToken(url, null, 'POST').then((response) => {
            if (response.hasOwnProperty('status')) {
                Object.entries(response?.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
                return false;
            } else if (response.hasOwnProperty('codigo')) {
                Swal.fire('Error', response.mensajes[0], 'error');
                return;
            }

            Swal.fire('Exito', 'Se inicio la descarga de  categorias', 'success');
        })
    }

    function handleChange(e) {
        setTipoCategoria(e.target.value);
    }

    function asignar(categoria_id) {
        Swal.fire({
            title: `¿Desea relacionar la categoria?`,
            showCancelButton: true,
            confirmButtonText: 'Relacionar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                var asignacion = {
                    sucursalOrg: getDataSession('sucursal'),
                    sucursalDes: getDataSession('sucursalPrincipal'),
                    categoriaOrg: categoria_id,
                    categoriaDes: 0
                };
                fetchConToken(`categorias/AsignarCategoria`, asignacion, 'PUT').then((response) => {
                    if (response.hasOwnProperty('status')) {
                        Object.entries(response.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
                        return false;
                    } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                        Swal.fire('Error', response.mensajes[0], 'error');
                        return false;
                    }

                    Swal.fire('Asignación completa', 'Categoria Relacionado', 'success');
                    setActualizarTabla(true);
                    setActualizarTabla(false);
                });
            }
        });
    }

    function desvincular(categoria_id) {
        Swal.fire({
            title: `¿Desea desvincular la categoria?`,
            showCancelButton: true,
            confirmButtonText: 'Desvincular',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                var desvincular = {
                    sucursalOrg: getDataSession('sucursal'),
                    sucursalDes: getDataSession('sucursalPrincipal'),
                    categoriaOrg: categoria_id,
                    categoriaDes: 0
                };
                fetchConToken(`categorias/DesvincularCategoria`, desvincular, 'PUT')
                    .then((response) => {
                        if (response.hasOwnProperty('status')) {
                            Object.entries(response?.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
                            return false;
                        } else if (response.hasOwnProperty('codigo')) {
                            Swal.fire('Error', response.mensajes[0], 'error');
                            return false;
                        }

                        Swal.fire('Exito', 'Categoria Desvinculado', 'success');
                        setActualizarTabla(true);
                        setActualizarTabla(false);
                    })
            }
        });
    }

    function validarSucursal() {
        return getDataSession('sucursal') !== getDataSession('sucursalPrincipal');
    }

    function publicar() {
        setModalValor('pulicador');
        openModalMarketPlace();
    }

    function Publicador(eCommerce) {
        setSucursales([]);
        if (noDisponible === eCommerce) {
            Swal.fire('Tienda no disponible');
            return;
        }

        getSucursalesTienda(eCommerce?.toUpperCase());
        setModalValor('seleccionarConexion');
    }

    function eliminar() {
        if (getDataSession('tienda') !== 'TIENDANUBE') {
            eliminarCategorias(false);
            return;
        }

        Swal.fire({
            title: '¿Desea eliminar las categorias de la Ecommerce?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: t('app.botones.eliminar') + ' de la Ecommerce',
            cancelButtonText: t('app.botones.eliminar') + ' del sistema'
        }).then((r) => eliminarCategorias(r.isConfirmed));
    }

    function eliminarCategorias(isConfirmed) {
        Swal.fire({
            title: '¿Desea eliminar las categorias?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: t('app.botones.eliminar'),
            cancelButtonText: t('app.botones.cancelar')
        }).then((result) => {
            if (result.isConfirmed) {
                var url = `Categorias/CategoriasBySucursal?sucursal_id=${getDataSession('sucursal')}&emrpesa_id=${getDataSession('empresa')}&eliminarmk=${isConfirmed}`;
                fetchConToken(url, null, 'DELETE').then((response) => {
                    if (response.hasOwnProperty('status')) {
                        Object.entries(response?.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
                        return false;
                    } else if (response.hasOwnProperty('codigo')) {
                        Swal.fire('Error', response.mensajes[0], 'error');
                        return;
                    }

                    Swal.fire('Exito', isConfirmed ? 'Proceso de eliminacion de categorias iniciado' : 'Categorias eliminadas correctamente', 'success');
                    setActualizarTabla(true);
                    setActualizarTabla(false);
                });
            }
        });
    }

    function duplicarOnClick() {
        let sucursales_ids = sucursales?.filter(x => x.checked);
        if (!sucursales_ids || sucursales_ids.length === 0) {
            Swal.fire('Error', 'Debe tener seleccionado por lo menos una conexion', 'error');
            return;
        }

        Swal.fire({
            title: `Desea duplicar y publicar o solo duplicar la categoria`,
            showCancelButton: true,
            confirmButtonText: 'Duplicar y Publicar',
            cancelButtonText: 'Ducplicar'
        }).then((result) => {
            var duplicar = {
                sucursalOrg: getDataSession('sucursal'),
                sucursalDes: sucursales_ids.find(x => x.checked).id,
                soloUtilizados: true,
                publicar: result.isConfirmed
            };
            fetchConToken(`Categorias/DuplicarCategoria`, duplicar, 'PUT').then((response) => {
                if (response.hasOwnProperty('status')) {
                    Object.entries(response?.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
                    return false;
                } else if (response.hasOwnProperty('codigo')) {
                    Swal.fire('Error', response.mensajes[0], 'error');
                    return false;
                }

                setCategorias(response);
                setModalValor('categorias');
                Swal.fire('Duplicado completo', result.isConfirmed ? 'Categorias duplicadas, proceso para publicar en curso' : 'Categorias duplicadas', 'success');
            })
        });
    }

    function IsSucursalPpal() {
        return getDataSession('sucursal') === getDataSession('sucursalPrincipal');
    }

    function IsTiendaDisponible() {
        return getDataSession('tienda') === 'TIENDANUBE' || getDataSession('tienda') === 'SHOPIFY';
    }

    if (!IsTiendaDisponible()) {
        const indexToRemove = columns.findIndex(column => column.headerName === 'Publicado');
        if (indexToRemove !== -1) columns.splice(indexToRemove, 1);
    }

    if (getDataSession('tienda') === 'MERCADOLIBRE') {
        const indexToRemove = columns.findIndex(column => column.headerName === '');
        if (indexToRemove !== -1) columns.splice(indexToRemove, 1);
    }

    if (getDataSession('sucursal') !== getDataSession('sucursalPrincipal') && getDataSession('tienda') !== 'MERCADOLIBRE') {
        columns.splice(1, 0, {
            field: 'padre.clave_Categoria', headerName: 'Cve. Orig.', width: 100, cellClassName: (params) => { return 'columna-art-padre' }, renderCell: (params) => (
                <a href={`${path + '/edit/' + params.row.padre?.id}`}>{params.row.padre ? params.row.padre.clave_Categoria : ''}</a>)
        });
        columns.splice(2, 0, {
            field: 'padre.nombre', headerName: 'Nom. Orig.', width: 100, cellClassName: (params) => { return 'columna-art-padre' }, renderCell: (params) => (
                <a href={`${path + '/edit/' + params.row.padre?.id}`}>{params.row.padre ? params.row.padre.nombre : ''}</a>)
        });
    }

    useEffect(() => {
        setGlobalTitulo(prev => ({
            ...prev,
            titulo: 'Categorias',
            subtitulo: 'Aqui se muestran todas las categorias por conexion'
        }));
        validarExisteSucursalPrincipal();
    }, [setGlobalTitulo]);

    return (<div className='container-fluid'>
        <div className='col-md-12'>
            <div className='col-md-12'>
                {getDataSession('tienda') !== 'MERCADOLIBRE' && (<>
                    <Link to={`${path}/add`} className='btn btn-outline-primary'>
                        <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='currentColor' className='bi bi-plus-square' viewBox='0 0 16 16'>
                            <path d='M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z' />
                            <path d='M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z' />
                        </svg>
                        &nbsp; Nuevo
                    </Link>&nbsp;&nbsp;&nbsp;
                </>)}
                {IsSucursalPpal() && (<><button className='btn btn-outline-primary' type='button' onClick={() => publicar()}><CloudUploadIcon /> &nbsp;Publicar categorias</button>&nbsp;&nbsp;&nbsp;</>)}
                {(getDataSession('rol') === "ADMINISTRADOR" || IsTiendaDisponible()) && (<>
                    <button className={IsTiendaDisponible() ? 'btn btn-outline-success' : 'btn btn-outline-danger'} type='button' onClick={() => descargar()}>
                        <CloudDownloadIcon /> &nbsp;Descargar/Actualizar categorias
                    </button>&nbsp;&nbsp;&nbsp;
                </>)}
                {getDataSession('tienda') !== 'MERCADOLIBRE' && (<button className='btn btn-outline-danger' type='button' onClick={() => eliminar()}><DeleteIcon /> &nbsp;Eliminar categorias</button>)}
            </div>
        </div>
        <div className='col-12 col-sm-12 col-md-12'>
            <ListTable
                hideFiltroExtra
                filtroExtra={FiltroTipoCategoria()}
                columns={columns}
                path={path}
                url={`Categorias/CategoriasGetList?sucursal_Id=${getDataSession('sucursal')}&tipo_Categoria=${tipoCategoria}`}
                reload={actualizarTabla}
            />
        </div>
        <Modal isOpen={isOpenModalMarketPlace} closeModal={closeModalMarketPlace}>
            {modalValor === 'seleccionarConexion' ? (<SelectorConexion sucursalesTienda={sucursales} setSucursalesTienda={setSucursales} onClickButton={duplicarOnClick} />) : ('')}
            {modalValor === 'pulicador' ? (<>
                <div className='espacio15px' />
                <h4 className='text-center'>Seleccione su e-Commerce</h4>
                <div className='col-md-12 row'>
                    <div className='col-sm-1' />
                    <div className='col-md-11 row'>
                        <button type='button' className='btn col-md-4 img_E-Commerce' onClick={() => { Publicador('WooCommerce') }}>
                            <img src={woocommerce} alt='WooCommerce' />
                        </button>
                        <button type='button' className='btn col-md-4 img_E-Commerce' onClick={() => { Publicador('Shopify') }}>
                            <img src={shopify} alt='Shopify' />
                        </button>
                        <button type='button' className='btn col-md-4 img_E-Commerce' onClick={() => { Publicador('TiendaNube') }}>
                            <img src={tiendanube} alt='TiendaNube' />
                        </button>
                    </div>
                </div>
            </>) : ('')}
            {modalValor === 'categorias' ? (<div className='card-body'>
                <div className='espacio20px' />
                <div style={{ overflowX: 'auto' }}>
                    <table className='table'>
                        <thead>
                            <tr>
                                <th >Id</th>
                                <th className='text-center'>Clave Categoria</th>
                                <th className='text-center'>Nombre</th>
                                <th className='text-center'>Publicado</th>
                            </tr>
                        </thead>
                        <tbody>
                            {categorias?.map((item) => {
                                return (
                                    <tr key={item.clave_Value}>
                                        <td className='text-center'>{item?.id}</td>
                                        <td className='text-center'>{item?.clave_Categoria}</td>
                                        <td className='text-center'>{item?.nombre}</td>
                                        <td className='text-center'>{item?.publicado ? 'S' : 'N'}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                <div className='espacio15px' />
            </div>) : ('')}
        </Modal>
    </div>);
};

export { List };
